module.exports = __webpack_public_path__ + "static/media/deleteIcon.a7609cc4.svg";